import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Landing from './LandingPage/landing';
import JudgePortal from './JudgePortal/JudgePortal';
import Contests from './Contests/Contests';
import Start from './Start/Start';
import ContestsNewStyle from './ContestsNewStyle/ContestsNewStyle';
import Users from './Users/Users';
import CompleteInvite from './Users/CompleteInvite';


export default (
    <Switch>
        <Route path='/app/judge-portal' component={JudgePortal}/>
        <Route path='/app/ContestsNewStyle' component={ContestsNewStyle}/>
        <Route path='/app/Contests' component={Contests}/>
        <Route path='/app/Start' component={Start}/>
        <Route path='/app/Users' component={Users}/>
        <Route path='/app/user/invite/:token' component={CompleteInvite}/>
        <Route path='/' component={Landing} />
    </Switch>
  )